// src/Components/ThankYouMessage.jsx
import React, { useEffect } from 'react';
import './ThankYouMessage.css';

const ThankYouMessage = ({ onComplete }) => {
  useEffect(() => {
    console.log('ThankYouMessage mounted, will redirect in 4 seconds');
    const timer = setTimeout(() => {
      console.log('Redirecting to dashboard...');
      if (onComplete) onComplete();
    }, 4000);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="thankyou-overlay">
      <div className="thankyou-modal">
        <div className="thankyou-icon">🎉</div>
        <h2>Thank You!</h2>
        <p>Your interview has been completed successfully.</p>
        <p className="thankyou-message">
          Our team will review your interview and get back to you within 3-5 business days.
        </p>
        <div className="thankyou-footer">
          <p>Redirecting to dashboard...</p>
          <div className="thankyou-spinner"></div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouMessage;